//
//
//
//
//
//
//
//
//
//
//
//
//

import { faHeart } from '@fortawesome/free-regular-svg-icons'

export default {
  name: 'TaskLikesSmall',
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  computed: {
    heartIcon () {
      return faHeart
    }
  }
}
